module.exports = __webpack_public_path__ + "img/cancel_black_24dp (1).e4e845b2.svg";